import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { mapSelectValue } from '../../../utils'
import { useEffect, useState } from 'react'
import { CheckBox } from 'react-native-elements'

const MdInformationForm = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const { loading, postMdOnline, getmodetails } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()

    const intialValues = {
        totalnoofexemptions: "",
        residence: '',
        filingstatus: '',
        additionalwithholding: '',
        claimexemptionfromwithholding: "",
        listOfStates: null,
        placeofabodeinMaryland: "",
        exemptfrommarylandlocaltax: "",
        incometax: "",
        year: "",
        age65: "",
        maximumNoOfExemptions: "",
        stateOfLegalResident: "",
        isMarylandWithholdingExempt: ""

    }

    const options1 = [
        { key: 1, value: 'Single' },
        { key: 2, value: 'Married (surviving spouse or unmarried Head of Household) Rate' },
        { key: 3, value: 'Married, but withhold at Single rate' }
    ]
    const options2 = [
        { key: 1, value: 'District of Columbia' },
        { key: 2, value: 'Virginia' },
        { key: 3, value: 'West Virginia' },
        { key: 4, value: 'None' }
    ]

    const options3 = [
        { key: 1, value: 'No' },
        { key: 2, value: 'Yes' }
    ]

    const getCheckedIds = () => {
        return checkboxes
            .filter(checkbox => checkbox.isChecked)
            .map(checkbox => checkbox.id);
    };

    const paschema = yup.object({
        residence: yup.string().required('Country of residence is a required field'),
        filingstatus: yup.string().required('Filing status is a required field'),
        additionalwithholding: yup.string().nullable(),
        claimexemptionfromwithholding: yup.mixed(),
        listOfStates: yup.string().nullable(),
        placeofabodeinMaryland: yup.string()
            .matches(/^exempt$/i, "Enter 'Exempt' or leave it empty")
            .nullable(),
        exemptfrommarylandlocaltax: yup.string()
            .matches(/^exempt$/i, "Enter 'Exempt' or leave it empty")
            .nullable(),
        incometax: yup.string()
            .matches(/^exempt$/i, "Enter 'Exempt' or leave it empty")
            .nullable(),
        year: yup.string().nullable(),
        maximumNoOfExemptions: yup.string().required('Total no of exemptions is a required field'),
        stateOfLegalResident: yup.string().nullable(),
        isMarylandWithholdingExempt: yup.string()
            .matches(/^exempt$/i, "Enter 'Exempt' or leave it empty")
            .nullable(),

    })

    const checkboxData = [
        { id: 1, title: 'Last year I did not owe any Maryland income tax and had a right to a full refund of all income tax withheld and', isChecked: false },
        {
            id: 2, title: 'This year I do not expect to owe any Maryland income tax and expect to have the right to a full refund of all income tax withheld.(This includes seasonal and student employees whose annual income will be below the minimum filing requirements).', isChecked: false
        },

    ];


    const [checkboxes, setCheckboxes] = useState(checkboxData);

    const toggleCheckbox = (id: any) => {
        const newCheckboxes = checkboxes.map(checkbox =>
            checkbox.id === id ? { ...checkbox, isChecked: !checkbox.isChecked } : checkbox
        );
        setCheckboxes(newCheckboxes);
    };





    useEffect(() => {
        getmodetails(initializestore?.initializeData?.userkey)
    }, [])


    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'MD Withholding '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={paschema}
                    onSubmit={async (values, actions) => {

                        const data = {
                            entityId: personalstore.personalData?.entityId,
                            essUserKey: initializestore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                            completeOnline: mode === 'upload' ? false : true,
                            county: values?.residence,
                            filingStatus: values?.filingstatus,
                            additionalWithholdings: Number(values?.additionalwithholding),
                            year: values?.year ? Number(values?.year) : null,
                            domiciledState: values?.listOfStates != null ? values?.listOfStates.toString() : null,
                            stateWithholdingExemption: values?.placeofabodeinMaryland,
                            claimExemptionsLastYear: getCheckedIds().includes(1) ? 1 : null,
                            claimExemptionsThisYear: getCheckedIds().includes(2) ? 2 : null,
                            localTaxExemption: values?.exemptfrommarylandlocaltax,
                            nonMarylandLocalTaxExemption: values?.incometax,
                            totalExemptions: Number(values?.maximumNoOfExemptions),
                            stateOfLegalResident: values?.stateOfLegalResident,
                            isMarylandWithholdingExempt: values?.isMarylandWithholdingExempt
                        }
                        const response = await postMdOnline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('mdonline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,
                                    claimExemptionsLastYear: getCheckedIds().includes(1) ? 1 : null,
                                    claimExemptionsThisYear: getCheckedIds().includes(2) ? 2 : null,
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }

                    }}
                >
                     {(props) => {
                        const isExempt = 
                            (getCheckedIds().includes(1) && getCheckedIds().includes(2)) ||
                            (props.values.listOfStates === 'DC' || props.values.listOfStates === 'VIRGINIA' || props.values.listOfStates === 'WEST VIRGINIA') ||
                            (props.values.placeofabodeinMaryland?.toLowerCase() === 'exempt') ||
                            (props.values.exemptfrommarylandlocaltax?.toLowerCase() === 'exempt') ||
                            (props.values.incometax?.toLowerCase() === 'exempt') ||
                            (props.values.isMarylandWithholdingExempt?.toLowerCase() === 'exempt');
                        return (
                            <>

                                <Card>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'County of residence (Nonresidents enter Maryland county (or Baltimore City) where you are employed.) *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.residence}
                                            onChangeText={(text) => {
                                                props.handleChange('residence')(text)
                                            }}
                                        />
                                        {props.touched.residence &&
                                            props.errors.residence && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.residence}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Total number of exemptions you are claiming not to exceed line f in Personal Exemption Worksheet on page 2 * '}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.maximumNoOfExemptions}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('maximumNoOfExemptions')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.maximumNoOfExemptions && props.errors.maximumNoOfExemptions && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.maximumNoOfExemptions}
                                            </Text>
                                        )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Filing status *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Filing status"
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.filingstatus
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('filingstatus', option)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.filingstatus &&
                                            props.errors.filingstatus && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.filingstatus}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                 {!isExempt && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Additional withholding per pay period under agreement with employer'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.additionalwithholding}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('additionalwithholding')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.additionalwithholding && props.errors.additionalwithholding && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.additionalwithholding}
                                                </Text>
                                            )}
                                        </View>
                                    </View>
                                )}


                                <View
                                    style={[
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'I claim exemption from withholding because I do not expect to owe Maryland tax. See instructions above and check boxes that apply. '
                                            }
                                        </Text>
                                    </View>

                                    <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                                        {checkboxes.map(checkbox => (
                                            <CheckBox
                                                key={checkbox.id}
                                                title={checkbox.title}
                                                checked={checkbox.isChecked}
                                                onPress={() => {
                                                    toggleCheckbox(checkbox.id);
                                                    const updatedCheckboxes = checkboxes.map(c =>
                                                        c.id === checkbox.id ? { ...c, isChecked: !c.isChecked } : c
                                                    )
                                                    const newCheckedIds = updatedCheckboxes
                                                        .filter(c => c.isChecked)
                                                        .map(c => c.id)
                                                    props.setFieldValue(
                                                        "claimexemptionfromwithholding",
                                                        newCheckedIds
                                                    );
                                                    if (newCheckedIds.includes(1) && newCheckedIds.includes(2)) {
                                                        props.setFieldValue('additionalwithholding', '')
                                                    }
                                                }}
                                                checkedColor="#0B495C"
                                                uncheckedColor="#0B495C"
                                                containerStyle={{
                                                    backgroundColor: 'transparent',
                                                    borderWidth: 0,
                                                    alignItems: 'flex-start',
                                                    width: '100%'
                                                }}
                                                textStyle={{
                                                    fontWeight: "normal",
                                                    color: "#0B495C",
                                                    flexShrink: 1,
                                                    textAlign: "left"
                                                }}
                                            />
                                        ))}
                                    </View>
                                    {props.touched.claimexemptionfromwithholding &&
                                        props.errors.claimexemptionfromwithholding && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.claimexemptionfromwithholding as string}
                                            </Text>
                                        )}
                                </View>


                                {getCheckedIds().length == 2 ?


                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'If both a and b apply, enter year applicable (year effective) * '}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.year}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('year')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.year &&
                                                props.errors.year && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.year}
                                                    </Text>
                                                )}
                                        </View>
                                    </View> : <></>}


                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'I claim exemption from withholding because I am domiciled in one of the following states. Select state that applies.'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="I claim exemption from withholding because I am domiciled in one of the following states. Select state that applies."
                                            options={options2}
                                            selectedOption={mapSelectValue(
                                                options2,
                                                props.values.listOfStates
                                            )}
                                            onSelect={(option: any) => {
                                                let stateVal = ""
                                                if (option == "1") {
                                                    stateVal = "DC"
                                                } else if (option == "2") {
                                                    stateVal = "VIRGINIA"
                                                } else if (option == "3") {
                                                    stateVal = "WEST VIRGINIA"
                                                }
                                                props.setFieldValue('listOfStates', stateVal)
                                                if (stateVal === "DC" || stateVal === "VIRGINIA" || stateVal === "WEST VIRGINIA") {
                                                    props.setFieldValue('additionalwithholding', '')
                                                }
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.listOfStates &&
                                            props.errors.listOfStates && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.listOfStates as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'I claim exemption from Maryland state withholding because I am domiciled in the Commonwealth of Pennsylvania and I do not maintain a place of abode in Maryland as described in the instructions on Form MW507.. Enter “EXEMPT” here'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.placeofabodeinMaryland}
                                            onChangeText={(text) => {
                                                props.handleChange('placeofabodeinMaryland')(text)
                                                if (text?.toLowerCase() === 'exempt') {
                                                    props.setFieldValue('additionalwithholding', '')
                                                }
                                            }}
                                        />
                                        {props.touched.placeofabodeinMaryland &&
                                            props.errors.placeofabodeinMaryland && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.placeofabodeinMaryland}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'I claim exemption from Maryland local tax because I live in a local Pennysylvania jurisdiction within York or Adams counties.Enter “EXEMPT” here and on line 4 of Form MW507 '}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.exemptfrommarylandlocaltax}
                                            onChangeText={(text) => {
                                                props.handleChange('exemptfrommarylandlocaltax')(text)
                                                if (text?.toLowerCase() === 'exempt') {
                                                    props.setFieldValue('additionalwithholding', '')
                                                }
                                            }}
                                        />
                                        {props.touched.exemptfrommarylandlocaltax &&
                                            props.errors.exemptfrommarylandlocaltax && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.exemptfrommarylandlocaltax}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'I claim exemption from Maryland local tax because I live in a local Pennsylvania jurisdiction that does not impose an earnings or income tax on Maryland residents.. Enter “EXEMPT” here and on line 4 of Form MW507 '}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.incometax}
                                            onChangeText={(text) => {
                                                props.handleChange('incometax')(text)
                                                if (text?.toLowerCase() === 'exempt') {
                                                    props.setFieldValue('additionalwithholding', '')
                                                }
                                            }}
                                        />
                                        {props.touched.incometax &&
                                            props.errors.incometax && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.incometax}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'I certify that I am a legal resident of the state of'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.stateOfLegalResident}
                                            onChangeText={(text) => {
                                                props.handleChange('stateOfLegalResident')(text)
                                            }}
                                        />
                                        {props.touched.stateOfLegalResident &&
                                            props.errors.stateOfLegalResident && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.stateOfLegalResident}
                                                </Text>
                                            )}
                                    </View>
                                </View>


                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'I certify that I am not subject to Maryland withholding because l meet the requirements set forth under the Servicemembers Civil Relief Act, as amended by the Military Spouses Residency Relief Act. Enter “EXEMPT” here'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.isMarylandWithholdingExempt}
                                            onChangeText={(text) => {
                                                props.handleChange('isMarylandWithholdingExempt')(text)
                                                if (text?.toLowerCase() === 'exempt') {
                                                    props.setFieldValue('additionalwithholding', '')
                                                }
                                            }}
                                        />
                                        {props.touched.isMarylandWithholdingExempt &&
                                            props.errors.isMarylandWithholdingExempt && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.isMarylandWithholdingExempt}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>
                        </>
                    )}}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default MdInformationForm
